import React from 'react';
import { ReportType } from '../../api/types/generated/reports_get.response';
import bar from '../../icons/reportTypes/bar.svg';
import barActive from '../../icons/reportTypes/bar-active.svg';
import line from '../../icons/reportTypes/line.svg';
import lineActive from '../../icons/reportTypes/line-active.svg';
import pie from '../../icons/reportTypes/pie.svg';
import pieActive from '../../icons/reportTypes/pie-active.svg';
import table from '../../icons/reportTypes/table.svg';
import tableActive from '../../icons/reportTypes/table-active.svg';

type ReportIconProps = {
  type: ReportType | undefined;
  active: boolean;
};

const ReportIcon = ({ type, active }: ReportIconProps) => {
  let icon, activeIcon;
  switch (type) {
    case 'bar':
      icon = bar;
      activeIcon = barActive;
      break;
    case 'line':
      icon = line;
      activeIcon = lineActive;
      break;
    case 'pie':
      icon = pie;
      activeIcon = pieActive;
      break;
    case 'table':
      icon = table;
      activeIcon = tableActive;
      break;

    default:
      icon = pie;
      activeIcon = pieActive;
      break;
  }

  return <img src={active ? activeIcon : icon} alt={type} />;
};

export default ReportIcon;
